<script>
import moment from "moment";
import { authUsuarioComputed } from "@/state/helpers";
import FilterProject from "@/components/commons/projects/FilterProject.vue";
import { mapActions, mapGetters } from "vuex";
import {
  MAP_STATUS_PURCHASE_REQUESTS,
  PLATAFORMA_STATUS_FILTER_OPTIONS,
} from "@/constants/supplying/purchaseRequests";
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
import config from "@/config";
import ModalMaterialsPurchaseRequest from "./ModalMaterialsPurchaseRequest.vue";
import swal2 from "sweetalert2";
import RequestDetails from "@/components/proyectos/lugarInstalacion/lugarSolicitudMaterial/approveRequests/RequestDetails.vue";
import { formatDateToFormatCommon } from "@/helpers/common";
import { email } from "vuelidate/lib/validators";
import { BUSINESS_UNIT_RESIDENTIAL_CODE } from "@/constants/presale";
import { getCustomProjectCodeIfIsOv } from "@/helpers/project";
export default {
  components: {
    FilterProject,
    ModalMaterialsPurchaseRequest,
    RequestDetails,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    requestPurchaseOrder: {
      type: Boolean,
      default: true,
    },
    requestingUserModule: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.getListEmployeesToAssignRequestOcData("");
    this.getPurchaseRequestsData();
    this.getUserIsSupplyingUserData();
  },
  data() {
    return {
      MAP_STATUS_PURCHASE_REQUESTS,
      PLATAFORMA_STATUS_FILTER_OPTIONS,
      REQUEST_SERVICE_CONSTANTS,
      BUSINESS_UNIT_RESIDENTIAL_CODE,
      moment,
      breadcrumb: [
        {
          text: "Proyectos",
          disabled: false,
          href: "/",
        },
        {
          text: "Solicitudes de compra",
          disabled: true,
          href: "/supplying/purchase-requests",
        },
      ],
      filters: {
        filter: "",
        page: 1,
        assigned_filter: null,
        assigned_user_email: "",
        purchase_request_id: "",
        sort_by: "created_at",
        sort_order: "desc",
        status: "Solicitado",
      },
      currentProject: null,
      dialogTraceabilityRequest: false,
      dialogMaterialsPurchaseRequest: false,
      loading: false,
      loadingPurchaseRequest: false,
      debounceRequests: null,
      debounceEmployees: null,
      debounceRequestsTime: 500,
      currentPurchaseRequest: false,
      userIsSupplyingUser: false,

      //Modal Approval List Materials Request
      dialogApprovalListMaterialsRequest: false,
      currentRequestMaterials: null,
      loadingRequestApprove: false,

      tableHeaders: [
        {
          text: "Acción",
          align: "center",
          value: "actions",
          className: "px-0",
          width: "3%",
          sortable: false,
        },
        {
          text: "Proyecto/OV/CECO",
          align: "start",
          sortable: true,
          value: "code",
          width: "15%",
        },
        {
          text: "Etapa proyecto",
          align: "start",
          sortable: false,
          value: "stage_code",
          width: "3%",
        },
        {
          text: "Código SAP",
          align: "start",
          sortable: true,
          value: "sap_code",
          width: "5%",
        },
        {
          text: "Tipo de solicitud",
          align: "center",
          sortable: false,
          value: "request_type.name",
          width: "10%",
        },
        {
          text: "Usuario que solicita",
          align: "center",
          sortable: true,
          value: "user",
          width: "10%",
        },

        {
          text: "Comprador Asignado",
          align: "center",
          sortable: false,
          value: "assigned_users",
          width: "15%",
        },
        {
          text: "Estatus",
          align: "center",
          sortable: false,
          value: "status",
          width: "5%",
        },
        {
          text: "Fecha de creación",
          align: "center",
          sortable: true,
          value: "created_at",
          width: "5%",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getProjects: "requestMaterialsSap/getProjects",
      getPurchaseRequests: "supplying/getPurchaseRequests",
      sendUpdateStatusPurchaseRequest: "supplying/updateStatusPurchaseRequest",
      getRequestMaterials: "requestMaterialsSap/getRequestMaterials",
      getMaterialsRequestsToApprove:
        "requestMaterial/getMaterialsRequestsToApprove",
      getListEmployeesToAssignRequestOc:
        "quote/getListEmployeesToAssignRequestQuote",
      assignBuyerToPurchaseRequest: "supplying/assignBuyerToPurchaseRequest",
      unassignBuyerFromPurchaseRequest:
        "supplying/unassignBuyerFromPurchaseRequest",
      getUserIsSupplyingUser: "requestService/getUserIsSupplyingUser",
    }),
    formatDateToFormatCommon,
    getCustomProjectCodeIfIsOv,
    async getListEmployeesToAssignRequestOcData(search = null) {
      let self = this;
      if (search === "" || search) {
        clearTimeout(self.debounceEmployees);
        self.debounceEmployees = await setTimeout(async function() {
          await self.getListEmployeesToAssignRequestOc({
            page: 0,
            password: config.password_manteiners,
            quotation_approvers: true,
            filter: search ?? undefined,
            items: 50,
          });
        }, self.debounceRequestsTime);
      }
    },
    async assignUserToRequest(value, request) {
      this.submitUpload = true;

      let payload = {
        purchase_request_id: request.id,
        assigned_user_mail: value,
      };

      const resp = await this.assignBuyerToPurchaseRequest(payload);
      if (!resp || !resp.status || resp.status == 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error en el servidor, intenta nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 200) {
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: `Usuario asignado correctamente`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });

        await this.getPurchaseRequestsData(this.filters.page);
      }
      this.loading = false;
    },

    // User Supplying
    async getUserIsSupplyingUserData() {
      if (this.user) {
        const resp = await this.getUserIsSupplyingUser({
          user: this.user.email,
        });
        this.userIsSupplyingUser = resp ? resp.is_abastecimiento : false;
      }
    },
    async getPurchaseRequestsData(page = 1) {
      clearTimeout(this.debounceRequests);
      this.debounceRequests = setTimeout(async () => {
        this.loadingPurchaseRequest = true;
        // Las opciones de plataforma (Solicitado / Parcialmente Comprado / Comprado)
        // se envían como `plataforma_status`; las legacy siguen usando `status_filter`
        const esStatusPlataforma = PLATAFORMA_STATUS_FILTER_OPTIONS.some(
          (option) => option.value === this.filters.status
        );
        await this.getPurchaseRequests({
          ...this.filters,
          page: page,
          filter: this.filters.filter ? this.filters.filter : undefined,
          project_filter: this.currentProject
            ? this.currentProject.split(" - ")[0]
            : undefined,

          // Mapea el key del estatus (ej. 'bost_Open') al valor numérico que el backend espera (1, 2, 3...)
          // Esto asegura que el filtro de estatus se envíe correctamente en la query string
          /// Mapea el key del estatus seleccionado (ej. 'bost_Open') al valor numérico que el backend espera (1, 2, 3...)
            // Esto asegura que el parámetro status_filter se envíe correctamente en la query string de la URL
            status_filter: !esStatusPlataforma && this.filters.status
            ? MAP_STATUS_PURCHASE_REQUESTS[this.filters.status].filter_value
            : undefined,
          plataforma_status: esStatusPlataforma
            ? this.filters.status
            : undefined,
          assigned_user: this.filters.assigned_filter || undefined,
          sort_order: this.filters.sort_order,
          // `status` es solo estado local del select, no es un parámetro del backend
          status: undefined,
        });
        this.loadingPurchaseRequest = false;
      }, this.debounceRequestsTime);
    },

    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by = sortBy == "code" ? "project" : sortBy;
        this.filters.sort_order = "asc";
        await this.getPurchaseRequestsData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getPurchaseRequestsData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getPurchaseRequestsData();
      }
    },
    updateCurrentProject(project_code) {
      this.currentProject = project_code;
    },
    cleanCurrentProject() {
      this.currentProject = null;
    },
    openModalTraceabilityRequests(purchaseRequest) {
      this.currentPurchaseRequest = purchaseRequest;
      this.dialogTraceabilityRequest = true;
    },
    closeModalTraceabilityRequests() {
      this.currentPurchaseRequest = null;
      this.dialogTraceabilityRequest = false;
    },
    openModalMaterialsPurchaseRequest(purchaseRequest) {
      this.currentPurchaseRequest = purchaseRequest;
      this.dialogMaterialsPurchaseRequest = true;
    },
    closeModalMaterialsPurchaseRequest() {
      this.currentPurchaseRequest = null;
      this.dialogMaterialsPurchaseRequest = false;
    },
    getMappedStatusPurchaseRequest(status) {
      return MAP_STATUS_PURCHASE_REQUESTS[status]
        ? MAP_STATUS_PURCHASE_REQUESTS[status]
        : { name: status, color: "grey darken-3" };
    },
    getColorFromStatusPlataform(status) {
      switch (true) {
        case status.includes("Parcialmente"):
          return "orange darken-1";
        case status.includes("Comprado"):
          return "purple darken-1";
        case status.includes("Recibido"):
          return "green darken-1";
        case status.includes("Cancelado"):
          return "red darken-1";
        default:
          return "primary";
          break;
      }
    },
    async updateStatusPurchaseRequest(newStatus, request) {
      let self = this;
      self.loading = true;
      let payload = {
        id: request.id,
        status: MAP_STATUS_PURCHASE_REQUESTS[newStatus].value,
        status_text: newStatus,
        user: self.user.email,
      };

      const resp = await self.sendUpdateStatusPurchaseRequest(payload);
      if (!resp.status || resp.status === 400) {
        self.loading = false;
        return swal2.fire({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 10000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 200) {
        swal2.fire({
          icon: "success",
          title: "Excelente",
          text: "Estatus de solicitud actualizado correctamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
      this.loading = false;
    },
    closeCurrentEditDialog(item) {
      this.$refs[`edit-dialog-${item.sap_code}`].isActive = false;
    },
    openCurrentEditDialog(item) {
      this.$refs[`edit-dialog-${item.sap_code}`].isActive = true;
    },
    async openModalApprovalListMaterialsRequest(requestPurchase) {
      this.loadingRequestApprove = true;
      let requestApprove = null;
      let responseRequestMaterials = await this.getRequestMaterials({
        filter: requestPurchase.sap_code,
      });
      if (
        responseRequestMaterials.items.length &&
        responseRequestMaterials.items[0].purchase_order
      ) {
        let responseApprovals = await this.getMaterialsRequestsToApprove({
          shopping_index: responseRequestMaterials.items[0].purchase_order,
        });
        if (responseApprovals.items.length) {
          requestApprove = responseApprovals.items[0];
        }
        this.currentRequestMaterials = requestApprove;
        this.dialogApprovalListMaterialsRequest = true;
      }

      if (!requestApprove) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `No se encontro una aprobación asociada a la solicitud de compra: ${requestPurchase.sap_code}`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      this.loadingRequestApprove = false;
    },
    closeModalApprovalListMaterialsRequest() {
      this.currentRequestMaterials = null;
      this.dialogApprovalListMaterialsRequest = false;
    },
    async changeProjectFilter() {
      this.getPurchaseRequestsData(1);
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      projects: "requestMaterialsSap/projects",
      purchaseRequests: "supplying/purchaseRequests",
      listBuyers: "supplying/buyersList",
      listEmployeesToAssignRequestOc: "quote/listEmployeesToAssignRequestQuote",
    }),
    wrappedPurchaseRequests() {
      //return this.purchaseRequests.items;
      return this.purchaseRequests.items
        ? this.purchaseRequests.items.map((i) => ({ ...i }))
        : [];
    },
    statusFilterItems() {
      const legacyItems = Object.entries(MAP_STATUS_PURCHASE_REQUESTS).map(
        ([key, item]) => {
          if (
            key === "bost_ReviewAbastecimiento" ||
            item.name.includes("Abastecimiento")
          ) {
            return {
              value: "Pendiente de revisión por Abastecimiento",
              name: item.name,
            };
          }
          return {
            value: key,
            name: item.name,
          };
        }
      );
      return [...PLATAFORMA_STATUS_FILTER_OPTIONS, ...legacyItems];
    },
    wrappedListEmployeesToAssignRequestOc() {
      return [
        {
          id: "null",
          email: "null",
          label: "No cotizar",
        },
        ...this.listEmployeesToAssignRequestOc.employees.map((item) => {
          return {
            label: `${item.email}`,
            ...item,
          };
        }),
      ];
    },
    wrappedHeaders() {
      if (this.requestQuote) {
        return this.tableHeaders.filter(
          (header) =>
            header.value !== "code" &&
            header.value !== "stage" &&
            header.value !== "material_request_type",
        );
      }
      return this.tableHeaders;
    },
  },
  watch: {
    "filters.page": function(page) {
      this.getPurchaseRequestsData(page);
    },
  },
};
</script>
<template>
  <v-container class="p-3 mt-5">
    <loading-flux :value="loading"></loading-flux>
    <section
      class="d-flex flex-column flex-sm-row justify-content-between"
      v-if="showHeader"
    >
      <h2 class="ml-1 my-2">Solicitudes de compra</h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </section>
    <v-row align-content="start" align-md="center" class="mt-1 mb-5">
      <v-col cols="12" md="4" sm="12" class="pb-0">
        <filter-project
          label="Filtrar por proyecto / OV"
          :projects="
            projects.items
              ? projects.items.filter((item) => item.warehouse)
              : []
          "
          :getProjectsFunction="getProjects"
          @cleanProject="cleanCurrentProject"
          @inputProject="
            updateCurrentProject($event);
            changeProjectFilter();
          "
        ></filter-project>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pb-0">
        <v-select
          v-model="filters.status"
          :items="statusFilterItems"
          @input="getPurchaseRequestsData(1)"
          item-text="name"
          item-value="value"
          label="Filtrar por estatus"
          clearable
        >
        </v-select>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pb-0">
        <v-text-field
          v-model="filters.filter"
          @input="getPurchaseRequestsData(1)"
          clearable
          placeholder="Buscar:"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pb-0">
        <v-autocomplete
          v-model="filters.assigned_filter"
          clearable
          :items="[
            {
              email: REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user,
              label: 'Sin Comprador Asignado',
            },
            ...wrappedListEmployeesToAssignRequestOc,
          ]"
          @input="getPurchaseRequestsData(1)"
          hide-details
          item-text="label"
          item-value="id"
          label="Filtrar por Comprador Asignado"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <div
      class="d-flex align-items-center justify-content-end mb-2 flex-column flex-sm-row mb-1"
    >
      <h5 class="my-0">
        Total:
        {{ purchaseRequests.total }}
      </h5>
    </div>
    <v-data-table
      class="px-1 elevation-3"
      :headers="tableHeaders"
      :items="wrappedPurchaseRequests"
      :items-per-page="10"
      :page.sync="filters.page"
      hide-default-footer
      :loading="loadingPurchaseRequest"
      @update:sort-by="updateSortBy"
      @update:sort-desc="updateSortDesc"
      loading-text="Cargando solicitudes de compra"
      no-data-text="Sin solicitudes de compra"
    >
      <template v-slot:item.project="{ item }">
        <p class="text-left my-0">
          {{ item.project ? "Proyecto" : "CECO" }}
        </p>
      </template>
      <template v-slot:item.code="{ item }">
        <p class="text-left my-0" style="font-size: 12.5px">
          {{ item.project ? getCustomProjectCodeIfIsOv(item.project) : item.cost_center.name }}
        </p>
      </template>
      <template v-slot:item.sap_code="{ item }">
        <p class="text-left my-0">
          {{ item.sap_code }}
        </p>
      </template>
      <template v-slot:item.stage_code="{ item }">
        <p class="my-0">
          {{
            item.stage_code &&
            item.project.business_unit_code !== BUSINESS_UNIT_RESIDENTIAL_CODE
              ? item.stage_code
              : "-"
          }}
        </p>
      </template>
      <template v-slot:item.user="{ item }">
        <span class="text-left my-0">
          {{ item.plataforma_user || "N/A" }}
        </span>
      </template>

      <template v-slot:item.assigned_users="{ item }">
        <v-autocomplete
          class="py-1 custom-font"
          :items="wrappedListEmployeesToAssignRequestOc"
          v-model="item.assigned_user"
          item-text="label"
          item-value="id"
          searchable
          placeholder="Selecciona un usuario"
          @change="assignUserToRequest($event, item)"
          hide-details
        ></v-autocomplete>
      </template>
      <template v-slot:item.status="{ item }">
        <v-edit-dialog>
          <div class="d-flex align-items-center justify-content-start">
            <v-chip
              label
              small
              :color="getColorFromStatusPlataform(item.status_plataforma)"
              class="text-white"
            >
              {{ item.status_plataforma }}
            </v-chip>
          </div>
          <template v-slot:input> </template>
        </v-edit-dialog>
        <!-- <div class="d-flex align-items-center justify-content-start">
          <v-chip
            label
            small
            :color="
              getMappedStatusPurchaseRequest(
                item.status_manual ? item.status_manual : item.status
              ).color
            "
            class="text-white"
          >
            {{
              getMappedStatusPurchaseRequest(
                item.status_manual ? item.status_manual : item.status
              ).name
            }}
          </v-chip>
        </div> -->
      </template>
      <template v-slot:item.created_at="{ item }">
        <span class="mt-2" style="font-size: 12px">
          {{ formatDateToFormatCommon(new Date(item.created_at)) }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-items-center justify-content-center">
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openCurrentEditDialog(item)"
                icon
                class="mx-2"
                color="warning"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>Modificar estatus de la solicitud</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalMaterialsPurchaseRequest(item)"
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon> mdi-view-list-outline </v-icon>
              </v-btn>
            </template>
            <span>Ver materiales de la solicitud</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalApprovalListMaterialsRequest(item)"
                icon
                :loading="loadingRequestApprove"
                class="mx-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon> mdi-account-check</v-icon>
              </v-btn>
            </template>
            <span>Ver Solicitud de Aprobación</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <div class="my-3 float-right">
      <v-pagination
        v-if="purchaseRequests.number_of_pages"
        total-visible="8"
        v-model="filters.page"
        :length="
          purchaseRequests.number_of_pages
            ? purchaseRequests.number_of_pages
            : 1
        "
      ></v-pagination>
    </div>
    <modal-materials-purchase-request
      :modalAction="dialogMaterialsPurchaseRequest"
      :closeModalMaterialsPurchaseRequest="closeModalMaterialsPurchaseRequest"
      :currentPurchaseRequest="currentPurchaseRequest"
    >
    </modal-materials-purchase-request>
    <RequestDetails
      ref="requestApprovalMaterialItems"
      :currentRequestMaterials="currentRequestMaterials"
      :modalAction="dialogApprovalListMaterialsRequest"
      :closeModalListMaterialsRequest="closeModalApprovalListMaterialsRequest"
    ></RequestDetails>
  </v-container>
</template>
<style></style>